// extracted by mini-css-extract-plugin
export default {"layout":"layout--Kkcmk","callingScreen":"callingScreen--H29ho","purchaseDetailsPopupContent":"purchaseDetailsPopupContent--Z7fse","animation-bzdot9":"animation-bzdot9--syqQN"};